import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  aboutYourBusinessHeading: {
    id: "funding-application: about your business heading",
    defaultMessage: "Tell us about your business model",
  },
  aboutYourBusinessSubheading: {
    id: "funding-application: about your business subheading",
    defaultMessage: "Select all that apply. This helps us show the right next steps for your business.",
  },
  formErrorPleaseSelect: {
    id: "funding-application: about your business form error",
    defaultMessage: "Select at least one option.",
  },
  formErrorFieldRequired: {
    id: "funding-application: about your business form error field required",
    defaultMessage: "Select at least one option.",
  },
  // Who do you sell to?
  whoYouSellToLabel: {
    id: "funding-application: who you sell to label",
    defaultMessage: "Who do you sell to?",
  },
  b2cLabel: {
    id: "funding-application: b2c label",
    defaultMessage: "End consumers (B2C)",
  },
  b2cHelperText: {
    id: "funding-application: b2c helper text",
    defaultMessage: "Individuals buying for personal use",
  },
  b2bLabel: {
    id: "funding-application: b2b label",
    defaultMessage: "Other businesses (B2B)",
  },
  b2bHelperText: {
    id: "funding-application: b2b helper text",
    defaultMessage: "Companies, retailers or distributors",
  },
  // Where do you sell?
  whereYouSellLabel: {
    id: "funding-application: where you sell label",
    defaultMessage: "Where do you sell?",
  },
  onlineLabel: {
    id: "funding-application: online label",
    defaultMessage: "Online",
  },
  onlineHelperText: {
    id: "funding-application: online helper text",
    defaultMessage: "Online stores, marketplaces, in-app or invoicing.",
  },
  offlineLabel: {
    id: "funding-application: offline label",
    defaultMessage: "Offline",
  },
  offlineHelperText: {
    id: "funding-application: offline helper text",
    defaultMessage: "At a physical store, location or by phone",
  },
  // What do you sell?
  whatYouSellLabel: {
    id: "funding-application: what you sell label",
    defaultMessage: "What do you sell?",
  },
  physicalProductsLabel: {
    id: "funding-application: physical products label",
    defaultMessage: "Physical products",
  },
  physicalProductsHelperText: {
    id: "funding-application: physical products helper text",
    defaultMessage: "Physical goods you manufacture or source",
  },
  digitalProductsLabel: {
    id: "funding-application: digital products label",
    defaultMessage: "Digital products",
  },
  digitalProductsHelperText: {
    id: "funding-application: digital products helper text",
    defaultMessage: "Digital content or downloads",
  },
  servicesLabel: {
    id: "funding-application: services label",
    defaultMessage: "Services",
  },
  servicesHelperText: {
    id: "funding-application: services helper text",
    defaultMessage: "Hospitality, professional services or repairs",
  },
  subscriptionsLabel: {
    id: "funding-application: subscriptions label",
    defaultMessage: "Subscriptions",
  },
  subscriptionsHelperText: {
    id: "funding-application: subscriptions helper text",
    defaultMessage: "SaaS, memberships or recurring billing",
  },
  bankAccountLabel: {
    id: "funding-application: bank accounts label",
    defaultMessage: "Bank accounts",
  },
  upcomingConnectionsTitle: {
    id: "funding-application: upcoming connections title",
    defaultMessage: "You'll connect your bank account and the relevant platforms later.",
  },
});
